import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Svg from '../../common/svgIcon';
import './styles.scss';

const KEYS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];

class NumericKeypad extends Component {

    removeSymbol() {
        const {
            value,
            targetId,
            setStake,
            onStakeUpdated,
        } = this.props;
        if (value) {
            const newValue = value.substring(0, value.length - 1);
            setStake(targetId, newValue)
            if (onStakeUpdated) {
                onStakeUpdated(newValue);
            }
        }
    }

    addSymbol(symbol) {
        const {
            value,
            targetId,
            setStake,
            onStakeUpdated,
        } = this.props;

        if (symbol === '.' && value.indexOf('.') !== -1) { // Prevent multiple '.'
            return;
        }

        const stakeParts = value.split('.');

        if (stakeParts[1] !== undefined && stakeParts[1].length === 2) { // 2 decimal places
            return;
        }

        const newValue = `${value}${symbol}`
        setStake(targetId, newValue)
        if (onStakeUpdated) {
            onStakeUpdated(newValue)
        }
    }

    render() {
        const {
            targetId,
            setIsEditingStake,
        } = this.props;

        return (
            <div className="bs-keypad">
                <div className="bs-keypad__wrapper">
                    <div className="bs-keypad__row">
                        {
                            KEYS.map((value, index) => (
                                <div
                                    className="bs-keypad__key"
                                    key={`key-${value}`}
                                >
                                    <button
                                        className={classNames(
                                            'bs-keypad__button',
                                            `bs-keypad__key_${value}`,
                                        )}
                                        tabIndex={index}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            this.addSymbol(value);
                                        }}
                                    >
                                        {value}
                                    </button>
                                </div>
                            ))
                        }
                    </div>
                    <div className="bs-keypad__row">
                        <div className="bs-keypad__key bs-keypad__key--point">
                            <button
                                className="bs-keypad__button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.addSymbol('.');
                                }}
                            >
                                .
                            </button>
                        </div>
                        <div className="bs-keypad__key bs-keypad__key--backspace">
                            <button
                                className="bs-keypad__button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.removeSymbol();
                                }}
                            >
                                <Svg
                                    iconName="backspace"
                                    className="bs-keypad__backspace"
                                />
                            </button>
                        </div>
                        <div className="bs-keypad__key bs-keypad__key--done">
                            <button
                                className="bs-keypad__button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setIsEditingStake(targetId, false);
                                }}
                            >
                                <span>Done</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

NumericKeypad.defaultProps = {
    onStakeUpdated: null,
}

NumericKeypad.propTypes = {
    targetId: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    setStake: PropTypes.func.isRequired,
    onStakeUpdated: PropTypes.func,
    setIsEditingStake: PropTypes.func.isRequired,
};

export default NumericKeypad;



// WEBPACK FOOTER //
// /src/js/common/numericKeypad/NumericKeypad.jsx